import React, { useState, useEffect, useReducer, useRef } from "react";
import {
  DataGrid,
  Column,
  Editing,
  Paging,
  Lookup,
  FilterRow,
  Toolbar,
  Item,
  Export,
  SearchPanel,
  RequiredRule,
} from "devextreme-react/data-grid";
import ScrollView from "devextreme-react/scroll-view";
import sa3Reducer from "../../reducers/sa3";
import Button from "devextreme-react/button";
import { alert } from "devextreme/ui/dialog";
import * as action from "../../actions/sa3";
import NEXUS_CONST from "../../common/constants";
import AsyncCallHandler from "../../common/AsyncCallHandler";
import { postLogForFilter } from "./utils";
import { postUserLog } from "../../actions/common";
import { isEmpty } from "lodash";
import { CompletionPlanStatus } from "./config";
import notify from "devextreme/ui/notify";
import moment from "moment";

const initialStates = {
  peopleList: [],
  sa3CompletionPlan: [],
  a3TeamMemers: []
};

const SA3CompletionPlan = (props: any) => {
  let {
    a3ID,
    siteId,
    data,
    activeItem,
    tierId,
    setisOpen,
    navigationOn,
    handleA3Save,
    isDataSaved,
    activeTab
  } = props;

  const [state, dispatch] = useReducer(sa3Reducer, initialStates);
  const { a3TeamMemers, sa3CompletionPlan } = state;
  let [distinctUsers, setDistinctUsers] = useState<any>([]);
  const [enableSave, setEanbleSave] = useState<any>(false);
  const [gridData, setGridData] = useState<any>([]);
  const dataGridRef = useRef<any>(null);

  useEffect(() => {
    //action.fetchUsers(dispatch, "tierId=" + tierId);
    action.fetchA3TeamMem(dispatch, "a3ID=" + a3ID);

    
    action.fetchSA3CompletionPlan(dispatch, a3ID);
    AsyncCallHandler(NEXUS_CONST.FETCH_A3_DATA + a3ID, NEXUS_CONST.GET).then(
      (res) => {
        if (res) {
          setEanbleSave(res?.data?.status === "Complete");
        }
      }
    );
  }, []);

  useEffect(() => {
    setGridData(sa3CompletionPlan);
  }, [sa3CompletionPlan]);

  function setStateValue(this: any, rowData: any, value: any) {
    this.defaultSetCellValue(rowData, value);
  }

  function onStatusChanged(
    this: any,
    rowData: any,
    value: any,
    data: any,
    formData: any
  ) {
    this.defaultSetCellValue(rowData, value);
    if (rowData.status) {
      if (value === "Completed")
        rowData.completedOn = moment(new Date()).format();
      else rowData.completedOn = null;
    } else if (rowData.completedOn && value !== null) {
      rowData.status = "Completed";
    }
  }

  useEffect(() => {
    setDistinctUsers([...a3TeamMemers]);
  }, [a3TeamMemers]);

  const saveCompletionPlan = () => {
    dataGridRef.current?.instance?.saveEditData();
    gridData?.forEach((item: any) => {
      item?.lsCause?.forEach((item1: any) => {
        if (typeof item1.id === "string") {
          item1.id = 0;
        }
      });
    });
    gridData.forEach((obj: any, index: number) => {
      if ("__KEY__" in obj) {
        gridData[index] = {
          id: 0,
          task: obj.task,
          metric: obj.metric,
          dueDate: obj.dueDate,
          owner: obj.owner,
          status: obj.status,
          completedOn: obj.completedOn,
          andon: obj.andon,
        };
      }
    });

    if (sa3CompletionPlan && sa3CompletionPlan?.length == 0) {
      alert("Please enter at least one completion plan", "Alert");
      return false;
    } else {
      let data = {
        a3ID: a3ID,
        completionPlan: gridData,
        lastSaved: "7",
        tierId : tierId,
        section:activeTab
      };

      AsyncCallHandler(
        NEXUS_CONST.MANAGE_A3_COMPLETION_PLAN,
        NEXUS_CONST.POST,
        data
      ).then((res) => {
        if (res.data) {
          action.fetchSA3CompletionPlan(dispatch, a3ID);
          isDataSaved(7);
          setisOpen("7");
          handleA3Save();
        }
      });
      isDataSaved(7);
      setisOpen("7");
      handleA3Save();
    }
  };

  const cellRenderColor = (cell: any) => {
    if (cell.value !== undefined)
      return (
        <div style={{ textAlign: "center", width: "20px", height: "20px" }}>
          <span
            style={{
              background: cell.value,
              textAlign: "center",
              marginLeft: "20px",
            }}
            className="rpsAndonDot"
          ></span>
        </div>
      );
  };

  function handleGridOptionChanged(e: any) {
    postLogForFilter(
      dataGridRef,
      e,
      siteId,
      tierId,
      "Completion Plan",
      7,
      a3ID,
      activeTab
    );
  }
  const initialstateConfig = {
    export: {
      enabled: true,
      fileName: "A3_CompletionPlan",
    },
  };
  const onInitNewRow = React.useCallback((e: any) => {
    e.data.id = sa3CompletionPlan.id;
    e.data.task = "";
    e.data.metric = "";
    e.data.dueDate = "";
    e.data.owner = "";
    e.data.status = "";
  }, []);

  const updateRowIndx = (e: any) => {
    // set("saActivI", e.rowIndex);
    // setRowVal(e.rowIndex);
  };
  return (
    <>
      <div className="title-section">
        {" "}
        <h2 className="sps_title">
          <span className="sps-print">Box 7 - &nbsp;</span>Completion Plan
        </h2>{" "}
        <div className="sps-save-btn save-btn">
          <Button
            style={{ float: "right", width: "140px", "margin-top": "3%" }}
            disabled={enableSave}
            width={200}
            onClick={saveCompletionPlan}
            text="Save"
            type="normal"
          />
        </div>
      </div>
      <ScrollView width="100%" height="420px" className="sps-box-s">
        <div>
          <DataGrid
            ref={dataGridRef}
            //  keyExpr="id"
            dataSource={gridData}
            allowColumnReordering={true}
            showBorders={true}
            wordWrapEnabled={true}
            width={"100%"}
            onOptionChanged={handleGridOptionChanged}
            {...initialstateConfig}
            onInitNewRow={onInitNewRow}
            onCellClick={updateRowIndx}
            onExporting={() =>
              postUserLog({
                event: `Box 7 - Completion Plan Export`,
                data: {
                  action: `Completion Plan exported for A3-${a3ID}`,
                  module: "Digital Tier",
                  section: activeTab,
                  siteUId: siteId,
                  widget: "Strategic A3",
                  tierId,
                },
              })
            }
          >
            <SearchPanel
              visible={true}
              onTextChange={(e) => {
                if (!isEmpty(e)) {
                  postUserLog({
                    event: "Box 7 - Completion Plan Grid Search",
                    data: {
                      action: `${e} searched in completion plan grid A3-${a3ID}`,
                      module: "Digital Tier",
                      section: activeTab,
                      siteUId: siteId,
                      widget: "Strategic A3",
                      tierId: tierId,
                    },
                  });
                }
              }}
            />
            <Toolbar>
              <Item location="after" visible={true} name="addRowButton" />
              <Item location="after" visible={true} name="exportButton" />
              <Item location="after" visible={true} name="revertButton" />
              <Item name="searchPanel" visible={true} />
            </Toolbar>
            <Export enabled={true} />
            <Paging enabled={false} />
            <Editing
              mode="batch"
              allowUpdating={true}
              allowAdding={true}
              allowDeleting={true}
              useIcons={true}
            />
            <FilterRow visible={true} />
            <Column
              dataField="isArchive"
              caption="IsArchive"
              visible={false}
              minWidth={20}
            ></Column>
            <Column
              dataField="id"
              visible={false}
              allowEditing={false}
              minWidth={20}
            ></Column>
            <Column
              dataField="task"
              caption="Task"
              visible={true}
              cssClass="WrappedColumn"
              width={200}
            >
              {" "}
              <RequiredRule />
            </Column>
            <Column dataField="metric" caption="Metric">
              <Lookup dataSource={data} valueExpr="title" displayExpr="title" />
              <RequiredRule />
            </Column>
            <Column
              dataField="dueDate"
              caption="Due Date"
              dataType="date"
              minWidth={20}
            >
              {" "}
              <RequiredRule />
            </Column>
            <Column dataField="owner" caption="Owner" minWidth={20}>
              <Lookup
                dataSource={distinctUsers}
                valueExpr="employeeId"
                displayExpr="employeeName"
              />{" "}
              <RequiredRule />
            </Column>
            <Column
              dataField="status"
              caption="Status"
              minWidth={20}
              setCellValue={onStatusChanged}
            >
              {" "}
              <RequiredRule />
              <Lookup dataSource={CompletionPlanStatus} />
            </Column>
            <Column
              dataField="completedOn"
              caption="Completed Date"
              dataType="date"
              minWidth={20}
              setCellValue={onStatusChanged}
            ></Column>

            <Column
              dataField="andon"
              caption="Andon"
              cellRender={cellRenderColor}
              allowEditing={false}
              width={80}
            ></Column>
          </DataGrid>
        </div>
      </ScrollView>
    </>
  );
};
export default SA3CompletionPlan;
